"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const material_1 = require("@angular/material");
const _4d_mapper_1 = require("4d-mapper");
const app_service_1 = require("../../../commons/app.service");
const rxjs_1 = require("rxjs");
const AppBaseComponent_1 = require("../../../commons/AppBaseComponent");
const router_1 = require("@angular/router");
const application_events_service_1 = require("../../../xs/services/events/application-events.service");
class ShareProjectDialog extends AppBaseComponent_1.AppBaseComponent {
    constructor(dialogRef, data, fourD, service, router, snackBar, dialog, activeRoute, applicationEvents) {
        super(service, router, snackBar, dialog, applicationEvents);
        this.dialogRef = dialogRef;
        this.data = data;
        this.fourD = fourD;
        this.service = service;
        this.router = router;
        this.snackBar = snackBar;
        this.dialog = dialog;
        this.activeRoute = activeRoute;
    }
    ok() {
        if (this.data.projects.length > 0 && this.shareAll !== undefined) {
            this.loading = true;
            rxjs_1.forkJoin(this.data.projects.map(project => {
                if (this.shareAll == false) {
                    return project.shareUsers.removeObservable(this.data.user);
                }
                else if (this.shareAll == true) {
                    return project.shareUsers.addObserveable(this.data.user);
                }
            })).subscribe(_ => {
                this.openSnackBarSuccess('USER_ADMIN.PROJECT_SHARED');
                this.loading = false;
                this.dialogRef.close();
            });
        }
        else {
            this.dialogRef.close();
        }
    }
    cancel() {
        this.dialogRef.close();
    }
    shareProject(checked, project) {
        this.shareAll = undefined;
        if (checked) {
            project.shareUsers.addObserveable(this.data.user).subscribe();
            if (!this.data.user['projects']) {
                this.data.user['projects'] = [];
            }
            if (this.data.user['projects'].indexOf(project) === -1) {
                this.data.user['projects'].push(project);
            }
        }
        else {
            project.shareUsers.removeObservable(this.data.user).subscribe();
            if (this.data.user['projects'].indexOf(project) !== -1) {
                this.data.user['projects'].splice(this.data.user['projects'].indexOf(project), 1);
            }
        }
    }
    shareAllProjects(event) {
        this.data.user['projects'] = [];
        if (event.checked) {
            this.data.projects.forEach(project => {
                this.data.user['projects'].push(project);
            });
        }
    }
}
exports.ShareProjectDialog = ShareProjectDialog;
